// import { getUserInfoApi } from '../utils/app';

export const isDev = process.env.NODE_ENV === 'development';
// 热门、动态字典
export const CIRCLE_SYSTEM_NAME = {
    /**
     * 热门
     */
    HOT: 'HOT',
    /**
     * 动态
     */
    ALL: 'ALL',
    /**
     * 其他
     */
    OTHER: 'OTHER',
};

// 圈子的Tag标签的调整权限
export const CIRCLE_TAG_PERMISSION = {
    /**
     * 是否展示、是否允许成员使用 皆无调整权限
     */
    CANNOT_VIEW_CANNOT_USE: 1,
    /**
     * 仅有是否展示的调整权限
     */
    CAN_VIEW_CANNOT_USE: 2,
    /**
     * 是否展示、是否允许成员使用的调整权限都有
     */
    CAN_VIEW_CAN_USE: 3,
    /**
     * 只有调整是否允许成员使用的权限
     */
    CANNOT_VIEW_CAN_USE: 4,
};
export const testToken = isDev ? 'A266048343775E1A1ED831C0FE3692BF' : '';
export const testUid = isDev ? '4000000089716937176' : '';
// export const ifengUid = getUserInfoApi?.getGuid() || testUid;
// 4000000089716545625
// 4000000089716545609

export const commentAppId = 'foKBq4TrE8JzKuox';

export const roleEnum = {
    /**
     * 圈主
     */
    OWNER: 'OWNER',
    /**
     * 黑名单
     */
    BLACK: 'BLACK',
    /**
     * 圈子用户
     */
    USER: 'USER',
    /**
     * 自己
     */
    SELF: 'SELF',
    /**
     * 他人
     */
    NOTSELF: 'NOTSELF',
    /** 游客身份 */
    TOURIST: 'TOURIST',
};

export const txtTypeEnum = {
    /**
     * 转发
     */
    FORWARD: 'forward',
};

export const opeatorEnum = {
    /**
     * 设为热门
     */
    HOT: 'hot',
    /**
     * 设为公告
     */
    TOP: 'top',
    /**
     * 删除
     */
    DETETE: 'delete',
};

// 加入圈子的状态
// 没有值说明没加入
export const JOINED_STATUS = {
    /**
     * 黑名单
     */
    BLACK: -1,
    /**
     * 申请加入
     */
    NOT_JOINED: 2,
    /**
     * 已加入
     */
    JOINED: 3,
    /**
     * 刚刚加入
     */
    JOINED_JUST_NOW: 4,
};

// export const picusBasePath = isDev
//     ? 'https://picus.ifeng.com/proxy/test-movie-comment'
//     : 'https://ifengcommoncomment.ifeng.com';
// export const linkBasePath = 'http://test.local.linkall.ifengidc.com';
// export const likeBasePath = isDev ? 'http://test0-ifeng-like.ifengidc.com' : 'https://ifenglike.ifeng.com';
// https://picus.ifeng.com

export const channelType = {
    PUBLISH: 'PUBLISH',
    LOCATION: 'LOCATION',
    MODIFY: 'MODIFY',
    ACTIONS: 'ACTIONS',
};
